import React from 'react';
import PropTypes from 'prop-types';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import { Logo, Mnemonic, WalletWrapper } from './styled';

const WalletRow = ({ wallet, openModal }) => {
  const coinImage =
    wallet.coin === 'BTC'
      ? `https://markets.bitcoin.com/images/coins/1.png`
      : `https://markets.bitcoin.com/images/coins/1831.png`;
  return (
    <WalletWrapper>
      <Logo>
        <img src={coinImage} alt={wallet.coin} height="32px" width="32px" />
        <span>{wallet.coin}</span>
      </Logo>
      <Mnemonic>
        <Button
          size={Button.Sizes.Small}
          design={Button.Designs.Danger}
          onClick={() => {
            openModal(wallet.mnemonic);
          }}
        >
          Show Mnemonic
        </Button>
      </Mnemonic>
    </WalletWrapper>
  );
};

WalletRow.propTypes = {
  wallet: PropTypes.shape({
    coin: PropTypes.string,
    derivationPath: PropTypes.string,
    mnemonic: PropTypes.string,
    walletId: PropTypes.string,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
};

export default WalletRow;
